import React, { useState } from "react";
import { Link } from "react-scroll";
import { Icon } from "@iconify/react";

const IntroVideo = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.muted = false; // Unmute the video
      videoElement
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Failed to play video:", err));
    }
  };

  return (
    <div className="w-full relative">
      <video
        className="min-h-[100vh] max-w-full w-full object-cover sm:object-contain sm:min-h-full"
        loop
        autoPlay
        playsInline
        muted
        preload="auto"
      >
        <source src="../../assets/videos/intro.mp4" type="video/mp4" />
      </video>

      {!isPlaying && (
        <div
          className="absolute inset-0 bg-black z-[9] bg-opacity-30 flex justify-center items-center"
          onClick={handlePlay}
        >
          <Icon
            icon="mdi:mute"
            width="70"
            height="70"
            className="cursor-pointer"
          />
        </div>
      )}

      <div className="absolute bottom-[2%] left-1/2 transform -translate-x-1/2">
        <Link to="home" smooth={true} duration={500} className="cursor-pointer">
          <img src="../../assets/images/home/scroll.png" alt="Scroll" />
        </Link>
      </div>
    </div>
  );
};

export default IntroVideo;
